'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "disabled", "field"];
import { BUTTON_DISABLED_TEXT, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import FilterFieldType from '../propTypes/FilterFieldType';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import classNames from 'classnames';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyRowButton = styled(UIButton).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "FieldSelectItemComponent__PropertyRowButton",
  componentId: "m20t4b-0"
})(["color:", ";cursor:", ";&:active,&:focus,&:hover{background-color:", ";}"], ({
  disabled
}) => disabled && `${BUTTON_DISABLED_TEXT} !important`, ({
  disabled
}) => disabled && 'not-allowed', ({
  disabled
}) => !disabled && `${CALYPSO_LIGHT} !important`);
const FieldSelectItemComponent = props => {
  const {
      children,
      className,
      disabled
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(PropertyRowButton, Object.assign({
    className: classNames(className, disabled && "disabled"),
    disabled: disabled
  }, rest, {
    children: children
  }));
};
FieldSelectItemComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  field: FilterFieldType
};
export default FieldSelectItemComponent;